import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import Button from "components/common/Button";
import TileGrid from "components/Screens/Marketplace/Customer/Shortlist/TileGrid";
import type { PreferenceTileView } from "components/Screens/Marketplace/Customer/utils/preferenceTiles";
import "./Shortlist.scss";

interface PreferencePopupProps {
  title: string;
  sub: string;
  tiles: PreferenceTileView[];
  onClose: (picked: PreferenceTileView[]) => void;
}

function PreferencePopup({ title, sub, tiles, onClose }: PreferencePopupProps) {
  const [selected, setSelected] = useState<string[]>([]);
  useEffect(() => setSelected([]), [title]);
  const toggle = (label: string) => setSelected((s) => (s.includes(label) ? s.filter((x) => x !== label) : [...s, label]));
  const finish = () => onClose(tiles.filter((t) => selected.includes(t.label)));

  return (
    <Dialog open onClose={finish} maxWidth="md" fullWidth slotProps={{ paper: { className: "sl-pref-pop" } }}>
      <IconButton aria-label="Close" className="sl-pref-pop__x" onClick={finish}>
        <CloseIcon />
      </IconButton>
      <h2 className="sl-pref-pop__title">{title}</h2>
      <p className="sl-pref-pop__sub">{sub}</p>
      <TileGrid tiles={tiles} selected={selected} onToggle={toggle} variant="rich" columns={5} />
      <div className="sl-pref-pop__foot">
        {selected.length ? (
          <>
            <span className="sl-pref-pop__done">
              <CheckIcon fontSize="small" />
              Noted. We will use this to find better matches.
            </span>
            <Button variant="contained" label="Done" onClick={finish} />
          </>
        ) : (
          <Button variant="text" label="Not now" onClick={finish} />
        )}
      </div>
    </Dialog>
  );
}

export default PreferencePopup;
